/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { PortalTopInformationFetcher } from "features/PortalTopInformation";
import React, { FC } from "react";

export const TopInformation: FC = () => {
  return <PortalTopInformationFetcher />;
};
